export { ModalConfirmacaoComponent } from './modal-confirmacao.component';
